// removed by extract-text-webpack-plugin
module.exports = {"btnGroup":"styles__btnGroup___3ld-n","input":"styles__input___1JBTy"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/ConsumptionProfile/components/SendForm/styles.css
// module id = 2929
// module chunks = 0